"use client";

import { Shield, Award, CheckCircle, ArrowRight, Phone } from "lucide-react";

interface AboutHeroProps {
    settings: any;
    heroData?: {
        title?: string;
        subtitle?: string;
        imageUrl?: string;
    };
}

export default function AboutHero({ settings, heroData }: AboutHeroProps) {
    const aboutHeroTitle = heroData?.title || "Geleceğinizi Birlikte Güvence Altına Alalım";
    const aboutHeroSubtitle = heroData?.subtitle || "15 yılı aşkın deneyimimizle, size ve sevdiklerinize en uygun sigorta çözümlerini sunmak için çalışıyoruz. Müşteri memnuniyetini ön planda tutarak, güvenilir ve yenilikçi hizmet anlayışımızla yanınızdayız.";

    const establishmentYear = settings?.establishmentYear || 2020;
    const yearsOfExperience = new Date().getFullYear() - establishmentYear;

    const heroImage = heroData?.imageUrl || "/assets/images/1.jpg";

    return (
        <section className="relative overflow-hidden bg-white">
            <div className="container mx-auto px-4 py-20 relative">
                <div className="flex flex-col lg:flex-row items-center gap-12">
                    <div className="lg:w-1/2">
                        {/* Üst Badge */}
                        <div className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium mb-6"
                            style={{
                                backgroundColor: 'color-mix(in srgb, var(--color-primary), transparent 90%)',
                                color: 'var(--color-primary)'
                            }}>
                            <Shield className="w-4 h-4 mr-2" /> {establishmentYear}'den Beri Hizmetinizde
                        </div>

                        {/* Başlık */}
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                            {aboutHeroTitle}
                        </h1>

                        <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                            {aboutHeroSubtitle}
                        </p>

                        {/* Butonlar */}
                        <div className="flex flex-wrap gap-4">
                            <button className="px-8 py-4 text-white rounded-xl font-semibold shadow-lg transition-all duration-300 flex items-center hover:scale-105"
                                style={{ background: `linear-gradient(to right, var(--color-primary), var(--color-secondary))` }}>
                                Hemen Teklif Al <ArrowRight className="ml-2 w-5 h-5" />
                            </button>

                            <button className="px-8 py-4 bg-white text-gray-800 border border-gray-300 rounded-xl font-semibold hover:bg-gray-50 transition-all duration-300 flex items-center"
                                onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--color-primary)'}
                                onMouseLeave={(e) => e.currentTarget.style.borderColor = '#d1d5db'}>
                                <Phone className="w-5 h-5 mr-2" style={{ color: 'var(--color-primary)' }} /> Bizi Arayın
                            </button>
                        </div>
                    </div>

                    {/* Görsel + Floating Stats */}
                    <div className="w-full lg:w-1/2">
                        <div className="relative">
                            <div className="relative min-h-60 lg:h-96 rounded-2xl lg:rounded-3xl overflow-hidden shadow-2xl border-4 border-white">

                                {/* YENİ STANDART IMG ETİKETİ - HATA ÇIKARTMAZ */}
                                <img
                                    src={heroImage}
                                    alt={aboutHeroTitle}
                                    className="absolute inset-0 w-full h-full object-cover"
                                    onError={(e) => {
                                        // Eğer resim silinmişse veya bulunamazsa placeholder göster
                                        e.currentTarget.src = "/assets/images/placeholder.png";
                                    }}
                                />

                                <div className="absolute inset-0"
                                    style={{ background: `linear-gradient(to top, color-mix(in srgb, var(--color-secondary), transparent 60%), transparent)` }}></div>
                            </div>

                            {/* Floating Card 1 (Deneyim) */}
                            <div className="absolute -top-4 -left-4 bg-white p-4 rounded-2xl shadow-lg border border-gray-100">
                                <div className="flex items-center">
                                    <div className="p-2 rounded-lg mr-3" style={{ backgroundColor: 'color-mix(in srgb, var(--color-primary), transparent 90%)' }}>
                                        <Award className="w-6 h-6" style={{ color: 'var(--color-primary)' }} />
                                    </div>
                                    <div>
                                        <div className="text-sm font-semibold text-gray-900">{yearsOfExperience}+ Yıl</div>
                                        <div className="text-xs text-gray-500">Sektör Deneyimi</div>
                                    </div>
                                </div>
                            </div>

                            {/* Floating Card 2 (Müşteri) */}
                            <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-2xl shadow-lg border border-gray-100">
                                <div className="flex items-center">
                                    <div className="p-2 bg-green-100 rounded-lg mr-3">
                                        <CheckCircle className="w-6 h-6 text-green-600" />
                                    </div>
                                    <div>
                                        <div className="text-sm font-semibold text-gray-900">50.000+</div>
                                        <div className="text-xs text-gray-500">Mutlu Müşteri</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}